import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import App from 'us_pcb_assembly/App';
import Cart from 'us_pcb_assembly/Cart';
import store from 'us_pcb_assembly/store/index';

document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.getElementById('quote-form');
  const cartContainer = document.getElementById('cart-form');

  if (appContainer != null) {
    render(
      <Provider store={store}>
        <App />
      </Provider>,
      appContainer,
    );
  }

  if (cartContainer) {
    render(
      <Provider store={store}>
        <Cart />
      </Provider>,
      cartContainer,
    );
  }
});
